import { render, staticRenderFns } from "./CreateLeave.vue?vue&type=template&id=1a6e336b&scoped=true&%3AroutePreventDialog=routePreventDialog&%3AcustomClass='leave-update'"
import script from "./CreateLeave.vue?vue&type=script&lang=js"
export * from "./CreateLeave.vue?vue&type=script&lang=js"
import style0 from "./CreateLeave.vue?vue&type=style&index=0&id=1a6e336b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6e336b",
  null
  
)

export default component.exports